import React, { Suspense, lazy } from 'react';
import MainLoader from '~components/main-loader';

const NewsItemPage = lazy(() => import('./index.js'))

function NewsItemPageLazy(props) {
    return (
        <Suspense fallback={<MainLoader />}>
            <NewsItemPage {...props} />
        </Suspense>
    );
}

export default NewsItemPageLazy;
export { NewsItemPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/news-item-page/lazy.js